import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    detailHeader: {
      borderBottom: '1px solid #cfcfcf',
      position: 'relative',
      top: -20
    },
    label: {
      width: '100px',
      textAlign: 'left',
      fontSize: 14
    },
    dateLabel: {
      width: '140px',
      textAlign: 'left',
      fontSize: 16
    },
    gridItem: {
      paddingBottom: 10
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    costSubContainer: {
      '@media screen and (min-width:600px)': {
        paddingLeft: 5,
        display: 'flex'
      }
    },
    imageListContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: 10
    },
    moveIcon: {
      position: 'relative',
      top: 1
    },
    visibilityHidden: {
      visibility: 'hidden'
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    },
    textItemWrapper: {
      wordBreak: 'break-all'
    }
  });
});
